import { useMutation } from '@tanstack/react-query';
import { getAccountConnectToken } from '@services/AccountConnectFormService';
import { config } from '../config';

export const useAccountConnectMutation = () => {
    return useMutation({
        mutationKey: ['account-connect'],
        mutationFn: async (url: string) => {
            const { response } = await getAccountConnectToken(`${config.env('ssoUrl')}`, `${config.env('xApiKey')}`);
            if (response) return { token: response?.signinToken, url };
            else throw new Error(`${url} is not a valid account connect`);
        },
        onError: () => {
            window.location.replace(`${config.env('myLoanBaseUrl')}`);
        }
    });
};
